import { useDispatch } from "react-redux";

import { updateData } from "../../redux/dataSlice";
import LeftIconButton from "../UI/buttonUI/LeftIconButton";
import { RotateCcw } from "lucide-react";
import { setIsFiltered, setFilteredData } from "../../redux/isTableFilterSlice";

const FilterReset = ({ setSelectedItems, originalData }) => {
  const dispatch = useDispatch();

  const filterReset = () => {
    dispatch(updateData(originalData));
    setSelectedItems({});
    document.querySelectorAll('input[type="checkbox"]');
    var checkboxes = document.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach(function (checkbox) {
      checkbox.checked = false;
    });
    // isFiltered slice states
    dispatch(setIsFiltered(false));
    dispatch(setFilteredData([]));
  };

  return (
    <LeftIconButton
      text="Reset"
      btnStyle="text-dark-blue bg-lg5 hover:bg-gray-200 mr-1 max-lg:text-xs"
      Icon={RotateCcw}
      iconStyle="max-lg:w-4"
      size={18}
      onClick={filterReset}
    />
  );
};

export default FilterReset;
